export default "__VITE_PUBLIC_ASSET__f21c4b74__"